export default "__VITE_ASSET__DvSuj_un__"